export default __webpack_public_path__ + "static/media/raffle-success.cd61da03.png";